module.exports = "<chassis-datatable-layout [title]=\"title\" [routePrefix]=\"routePrefix\" [pluginPrefix]=\"pluginPrefix\" [(table)]=\"table\"></chassis-datatable-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/pages/tenants/index/index.page.html
// module id = ./libs/chassis-core/src/app/pages/tenants/index/index.page.html
// module chunks = main